import { login } from "../../../api/auth";
import axios from "../../../api/axios";

const useLogin = () => {
  const authenticate = async (form) => {
    const { data, token, error } = await axios.post("/users/login-customer", {
      ...form,
    });

    if (error) throw new Error(error);
    login({ data, token });

    return data;
  };

  return { authenticate };
};

export default useLogin;
